var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{attrs:{"options":_vm.highChartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }